import { useCallback } from 'react';
import { toast } from 'sonner';
import { getTotalRecords, getRows } from '@/utils'; //FetchHelpers
import contactTypeService from '@/services/contact/contactTypeService';

const toContactTypeOptions = (rows) =>
  rows.map(type => ({
    label:  type.name,
    value: type.id.toString(),
    id: type.id.toString(),
    original: type,
  }));


const useContactTypeOptions = ({ defaultPageSize = 20 } = {}) => {
  const loadOptions = useCallback(
    async ({ search = '', page = 1, pageSize = defaultPageSize } = {}) => {
      try {
        const response = await contactTypeService.getAllContactsType({
          page,
          pageSize,
          search,
        });

        const status =
          typeof response?.status === 'boolean' ? response.status : true;
        if (!status) return { options: [], hasMore: false };

        const rows = getRows(response);
        const options = toContactTypeOptions(rows);

        const totalRecords = getTotalRecords(response);
        const hasMore =
          typeof totalRecords === 'number'
            ? page * pageSize < totalRecords
            : options.length === pageSize;

        return { options, hasMore };
      } catch (error) {
        console.error('Error', error);
        toast.error('Failed to fetch Contact Types.', {
          description: 'Please try again.',
        });
        return { options: [], hasMore: false };
      }
    },
    [defaultPageSize]
  );

  return loadOptions;
};

export { useContactTypeOptions };